import React, { SVGAttributes } from 'react';
import { useThemeContext } from '../../hooks/useThemeContext';

export function Warning(props: SVGAttributes<SVGElement>) {
    const theme = useThemeContext();
    return (
        <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle fill={theme.colors.warning['30']} cx="8" cy="8" r="8" />
                <g stroke={theme.colors.neutral['0']} strokeWidth="2">
                    <path d="M8 3.333v5.834M8 10.625v1.75-1.75z" />
                </g>
            </g>
        </svg>
    );
}
